var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBannerBgRing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 223,
    height: 247,
    viewBox: "0 0 223 247",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_335_70)"
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.04,
    cx: 99.5,
    cy: 123.5,
    r: 100,
    stroke: "#5C2684",
    strokeWidth: 47
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_335_70"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 223,
    height: 247,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerBgRing);
export default __webpack_public_path__ + "static/media/banner-bg-ring.f42871270d68cf59d8b0aaccacabe4b9.svg";
export { ForwardRef as ReactComponent };